function  Map() {
    return <iframe title="map" className="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2381.6231073571316!2d-3.022198283937408!3d53.350002579979744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487ad89fa10fac55%3A0x66a04f1320c9dad2!2sBebington%20Podiatry!5e0!3m2!1sen!2suk!4v1676292271775!5m2!1sen!2suk" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
}

export default Map;